import React from 'react';
import PropTypes from 'prop-types';
import FulfilmentLocationsDialog from '../FulfilmentLocationsDialog';
import useLocationSettings from '../../utils/useLocationSettings';

const SwitchLocationsDialog = ({ isOpen, onCancel, onSwitch }) => {
  const { locationSettings, saveLocationSettings } = useLocationSettings({
    fetchLocationsEnabled: isOpen,
  });

  const handleSwitchLocations = ({ locations }) => {
    saveLocationSettings(locations);

    if (onSwitch && typeof onSwitch === 'function') {
      onSwitch();
    }
  };

  return (
    <FulfilmentLocationsDialog
      isOpen={isOpen}
      locations={locationSettings}
      onCancel={onCancel}
      onSubmit={handleSwitchLocations}
      multiple
    />
  );
};

SwitchLocationsDialog.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  onSwitch: PropTypes.func,
};

SwitchLocationsDialog.defaultProps = {
  isOpen: false,
  onCancel: undefined,
  onSwitch: undefined,
};

export default SwitchLocationsDialog;
